import * as React from 'react';
import { Link } from 'react-router-dom';
import { MdLink, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { routeConstants } from 'app/routes/route-constants';
import { When } from './when';
import { MenuAccess } from '../../../types';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  menuAccess: MenuAccess;
  onItemClick: () => void;
}

export const ToolsExternalUrlsMenuItem = ({ translation, menuAccess, onItemClick }: Props) => (
  <When condition={menuAccess.externalUrlAdministration}>
    <li>
      <input type="checkbox" id="mobile-admin-external-urls" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdLink className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.external_urls}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-admin-external-urls">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.externalUrlList} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.external_url}
            </span>
          </Link>
        </li>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.externalUrlGroupsList} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.external_url_groups}
            </span>
          </Link>
        </li>
      </ul>
    </li>
  </When>
);
